/* eslint-disable no-underscore-dangle */
import Vue from 'vue';
import VueWaypoint from 'vue-waypoint';

import { createApp } from './entry';

Vue.use(VueWaypoint);

Vue.mixin({
  beforeRouteUpdate(to, from, next) {
    const { asyncData } = this.$options;
    if (asyncData) {
      asyncData({
        store: this.$store,
        route: to,
      }).then(next).catch(next);
    } else {
      next();
    }
  },
});

const { app, router, store } = createApp();

if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__);
}

router.onReady(() => {
  app.$mount('#app');
});



// WEBPACK FOOTER //
// ./src/entry-client.js